// John Eldhose 20200622
import React, { Component } from 'react';
import { Checkbox, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import Loading from '../../lib/Loading';
import { postAcademy } from './lib';
import CourseList from './CourseList';

class ContentLibrary extends Component {

  state = {
    loading: true
  }
  properties = {};
  componentWillMount() {
    postAcademy('ContentLibrary', {}, (res) => {
      res.data.map((prop) => {
        if(typeof this.properties[prop.parent] === 'undefined')
          this.properties[prop.parent] = [];
        this.properties[prop.parent][prop.id] = prop.child;
        return true;
      });
      this.setState({ loading: false });
    });
  }
  handleSearch = (e) => {
    var s = JSON.parse(JSON.stringify(this.props.search));
    if(e.target.checked) {
      if(typeof s[e.target.name] === 'undefined')
        s[e.target.name] = [];
      if(!s[e.target.name].includes(e.target.value)) {
        s[e.target.name].push(e.target.value);
        this.props.setSearch(s);
      }
    }
    else {
      if(
        typeof s[e.target.name] !== 'undefined' &&
        s[e.target.name].includes(e.target.value)
      ) {
        s[e.target.name] = s[e.target.name].filter(
          (val) => (val !== e.target.value)
        );
        this.props.setSearch(s);
      }
    }
  }
  handleTopic(e, top) {
    var s = JSON.parse(JSON.stringify(this.props.search));
    var tops = (typeof s.topic === 'undefined') ? {} : s.topic;
    if(e.target.name === 'topic') {
      if(e.target.checked)
        tops[e.target.value] = Object.values(this.properties[e.target.value]);
      else if(typeof tops[e.target.value] !== 'undefined')
        delete tops[e.target.value];
      s.topic = tops;
      this.props.setSearch(s);
    }
    else if(e.target.name === 'subtopic') {
      if(e.target.checked) {
        if(typeof tops[top] === 'undefined')
          tops[top] = [];
        if(!tops[top].includes(e.target.value))
          tops[top].push(e.target.value);
        s.topic = tops;
        this.props.setSearch(s);
      }
      else if(typeof tops[top] !== 'undefined') {
        if(tops[top].includes(e.target.value))
          tops[top] = tops[top].filter(
            (val) => (val !== e.target.value)
          );
        if(tops[top].length === 0)
          delete tops[top];
        s.topic = tops;
        this.props.setSearch(s);
      }
    }
  }
  curriculum = () => {
    var curs = (typeof this.props.search.curriculum === 'undefined') ? [] : this.props.search.curriculum;
    return (
      <div>
        <Typography variant='subheading'><b>Curriculum</b></Typography>
        {this.properties['_curriculum'].map((cur, cid) => (
          <Grid container key={cid} alignItems='center'>
            <Grid item>
              <Checkbox
                color='primary'
                name='curriculum'
                value={cur}
                onChange={this.handleSearch}
                checked={curs.includes(cur)}
              />
            </Grid>
            <Grid item><Typography>{cur}</Typography></Grid>
          </Grid>
        ))}
        <Divider style={{ margin: '15px' }} />
      </div>
    );
  }
  topic = () => {
    var tops = (typeof this.props.search.topic === 'undefined') ? {} : this.props.search.topic;
    var i = 0;
    return (
      <div style={{ border: 'solid silver 1px', height: '300px', overflowX: 'auto', margin: '10px 0' }}>
        {this.properties._topic.map((top, tid) => (
          <Grid container key={tid}
            alignItems='center'
            style={{ backgroundColor: ((i++ % 2) ? '#ebf5fb' : '#fff'), borderBottom: 'solid #ddd 1px' }}
          >
            <Grid item>
              <Checkbox
                color='primary'
                name='topic'
                value={top}
                onChange={(e) => this.handleTopic(e, '')}
                checked={typeof tops[top] !== 'undefined' && tops[top].length === Object.values(this.properties[top]).length}
              />
            </Grid>
            <Grid item>
              <Typography>{top}</Typography>
            </Grid>
            {this.properties[top].map((stop, stid) => (
              <Grid container key={stid}
                alignItems='center'
                style={{ paddingLeft: '17px' }}
              >
                <Grid item>
                  <Checkbox
                    color='primary'
                    name='subtopic'
                    value={stop}
                    onChange={(e) => this.handleTopic(e, top)}
                    checked={typeof tops[top] !== 'undefined' && tops[top].includes(stop)}
                  />
                </Grid>
                <Grid item><Typography>{stop}</Typography></Grid>
              </Grid>
            ))}
          </Grid>
        ))}
      </div>
    );
  }
  skilllevel = () => {
    var sls = (typeof this.props.search.skilllevel === 'undefined') ? [] : this.props.search.skilllevel;
    return (
      <div>
        <Typography variant='subheading'><b>Skill level</b></Typography>
        {this.properties['Skill level'].map((sl, sid) => (
          <Grid container key={sid} alignItems='center'>
            <Grid item>
              <Checkbox
                color='primary'
                name='skilllevel'
                value={sl}
                onChange={this.handleSearch}
                checked={sls.includes(sl)}
              />
            </Grid>
            <Grid item><Typography>{sl}</Typography></Grid>
          </Grid>
        ))}
        <Divider style={{ margin: '15px' }} />
      </div>
    );
  }
  language = () => {
    var lngs = (typeof this.props.search.language === 'undefined') ? [] : this.props.search.language;
    return (
      <div>
        <Typography variant='subheading'><b>Language</b></Typography>
        {this.properties['Language'].map((lng, lid) => (
          <Grid container key={lid} alignItems='center'>
            <Grid item>
              <Checkbox
                color='primary'
                name='language'
                value={lng}
                onChange={this.handleSearch}
                checked={lngs.includes(lng)}
              />
            </Grid>
            <Grid item><Typography>{lng}</Typography></Grid>
          </Grid>
        ))}
      <Divider style={{ margin: '15px' }} />
      </div>
    );
  }

  render() {
    if(this.state.loading)
      return <Loading />;
    else
      return (
        <Grid container>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={2}>
            <Grid container alignItems='center'>
              <Grid item>
                <IconButton
                  color='secondary'
                  onClick={() => this.props.setSearch({})}
                  disabled={Object.keys(this.props.search).length === 0}
                >
                  <Delete style={{ transform: 'scale(.7)' }} />
                </IconButton>
              </Grid>
              <Grid item>
                <Typography variant='caption'>Clear all selections</Typography>
              </Grid>
            </Grid>
            <Typography variant='subheading'><b>Topic</b></Typography>
            {this.topic()}
            <Divider style={{ margin: '15px' }} />
            {this.curriculum()}
            {this.skilllevel()}
            {this.language()}
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={9} xl={10}>
            <CourseList
              orientation='vertical'
              search={{
                by: 'ContentLibrary', search: this.props.search, limit: 25
              }}
            />
          </Grid>
        </Grid>
      );
  }
}

export default ContentLibrary;



// WEBPACK FOOTER //
// ./src/components/home/academy/ContentLibrary.js